import type { ReactNode } from 'react'
import { useFeature } from '@/hooks'

interface FeatureGateProps {
  /** Deployment feature flag name, e.g. 'voice', 'whatsapp', 'commerce'. */
  feature: string
  children: ReactNode
}

/**
 * Show `children` only when `feature` is enabled for this deployment.
 * Use inside MDX to gate a content block:
 *
 *   <FeatureGate feature="voice">
 *   ...voice-only docs...
 *   </FeatureGate>
 */
export function FeatureGate({ feature, children }: FeatureGateProps) {
  const enabled = useFeature(feature)
  if (!enabled) return null
  return <>{children}</>
}
